export class AppLoadingDots extends HTMLElement {
    connectedCallback() {
        if (this.shadowRoot) return;
        this.attachShadow({ mode: 'open' }).innerHTML = `
            <style>
                :host { display: inline-flex; align-items: center; gap: 6px; }
                span {
                    width: 8px;
                    height: 8px;
                    background-color: color-mix(in srgb, var(--text) 25%, transparent);
                    border-radius: 50%;
                    animation: app-loading-dots-pulse 1.2s ease-in-out infinite;
                }
                :host([variant="running"]) { gap: 4px; }
                :host([variant="running"]) span {
                    width: 5px;
                    height: 5px;
                    background-color: var(--accent);
                }
                span:nth-of-type(1) { animation-delay: 0s; }
                span:nth-of-type(2) { animation-delay: 0.2s; }
                span:nth-of-type(3) { animation-delay: 0.4s; }
                @keyframes app-loading-dots-pulse {
                    0%, 60%, 100% { opacity: 0.25; transform: scale(0.8); }
                    30%           { opacity: 1;    transform: scale(1);   }
                }
            </style>
            <span></span><span></span><span></span>
        `;
    }
}

if (!customElements.get('app-loading-dots')) {
    customElements.define('app-loading-dots', AppLoadingDots);
}